import React, { useRef } from "react";
// import "./LandingPageGsap.css";
import "./Sample.css";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/all";
import gsap from "gsap";
import { motion, useScroll, useTransform } from "framer-motion";
import Bubbles from "../Common/Bubbles";
import PackingSection from "../PackingSection/PackingSection";
import Footer from "../Footer/Footer";
import Truck from "../Truck/Truck";
import OurService from "../OurService/OurService";
import WhyChoseUs from "../WhyChooseUs/WhyChoseUs";
export default function LandingPageGsap() {
  const container = useRef();
  const wrapper = useRef();
  const { scrollYProgress } = useScroll({
    target: container,

    offset: ["start end", "end start"],
  });

  gsap.registerPlugin(useGSAP, ScrollTrigger);
  useGSAP(
    () => {
      gsap.from(".lp-wrapper1 .dd", {
        opacity: 0,
        duration: 1,
        delay: 1,
        stagger: 0.1,
      });
      gsap.from(".subheadLineDesc", {
        opacity: 0,
        duration: 1,
        y: 10,
      });

      gsap.to(".lp-wrapper1 .dd", {
        scrollTrigger: {
          trigger: ".lp-wrapper1 ",
          scroller: "body",
          // markers: true,
          start: "top -30px",
          end: "bottom 50%",
          scrub: true,
        },
        xPercent: -50,
        left: "50%",
        yPercent: -0,
        top: "100%",
        position: "absolute",
        transform: "rotate(0deg)",
        // marginTop: 50,
        display: "none",
        delay: 1,
        duration: 2,
      });
    }
    // { scope: wrapper }
  );
  return (
    <>
      <div className="lp-container">
        <div ref={wrapper} className="lp-wrapper1">
          <div className="box1 dd"></div>
          <div className="box2 dd"></div>
          <div className="box3 dd"></div>
          <div className="box4 dd"></div>
          <div className="box5 dd"></div>
          <div className="box6 dd"></div>
          <div className="box7 dd"></div>
          <div className="box8 dd"></div>
          <div className="Subheadline">
            <p className="subheadLineDesc text-[34px] sm:text-[44px] md:text-[74px]">
              Transforming your laundry experience with care, precision, and
              joy.
            </p>
            <p className="subheadLineDescSmall">
              Scroll down to see the magic !!!
            </p>
          </div>
          {/* BUBBLES */}
        </div>

        <div className="lp-wrapper2 ">
          <div className="bubble-wrap1">
            <Bubbles />
          </div>
          {/* WASHING M/C */}
          <div className="mc">
            <div className="washingmc"></div>
          </div>
          {/* BUBBLES */}

          {/* MARQUEE */}
          <div className="Marquee" ref={container}>
            <Slide direction={"left"} progress={scrollYProgress} />
          </div>
        </div>
        <div className="hdiwhero">
          <PackingSection />
        </div>
        <div className="relative h-auto top-[100px] md:top-[10px] flex flex-col justify-center items-center">
          <OurService />
        </div>
        <div className="relative h-auto top-[140px] md:top-[50px] flex flex-col justify-center items-center">
          <WhyChoseUs />
        </div>
        <div className="deliveryScetion flex flex-col justify-center items-center">
          <Truck />
        </div>
        <div className="w-full bg-black flex justify-center items-center ">
          <Footer />
        </div>
      </div>
    </>
  );
}

const Slide = (props) => {
  const direction = props.direction === "left" ? 1 : -1;

  const translateX = useTransform(
    props.progress,
    [0, 1],
    [150 * direction, -150 * direction]
  );
  return (
    <motion.div
      style={{
        display: "flex",
        x: translateX,
      }}
    >
      <Phrase styles={0} />
      <Phrase styles={1} />
      <Phrase styles={0} />
      <Phrase styles={1} />
      <Phrase styles={0} />
      <Phrase styles={1} />
      <Phrase styles={0} />
      <Phrase styles={1} />
    </motion.div>
  );
};
const Phrase = ({ styles }) => {
  return (
    <div className="spin-wrapper">
      <p className={styles ? "spin" : "spin2"}>{styles ? "SPIN" : "DRY"}</p>
    </div>
  );
};
